export default __webpack_public_path__ + "static/media/pageNotFound.8152c74f.jpg";